<template>
    <div>
        <certificate-data-view class="my-3"></certificate-data-view>
    </div>
</template>

<script>
import CertificateDataView from "@/components/study/CertificateDataView";
export default {
    name: "AdminCertificateDataManage",
    components: {CertificateDataView},
    data: function () {
        return {};
    },
    mounted() {

    },
    methods: {}
}
</script>

<style scoped>

</style>